// This file is auto-generated by @hey-api/openapi-ts

import type { CancelablePromise } from './core/CancelablePromise';
import { OpenAPI } from './core/OpenAPI';
import { request as __request } from './core/request';
import type { HealthRootHealthzGetResponse, CheckDatabaseHealthzDbGetResponse, GetStationsCommonStationsListGetData, GetStationsCommonStationsListGetResponse, GetStationByIdCommonStationsStationIdGetData, GetStationByIdCommonStationsStationIdGetResponse, DeleteStationCommonStationsStationIdDeleteData, DeleteStationCommonStationsStationIdDeleteResponse, UpsertStationCommonStationsPostData, UpsertStationCommonStationsPostResponse, BulkGeocodingUpdateCommonStationsBulkGeocodingUpdatePostData, BulkGeocodingUpdateCommonStationsBulkGeocodingUpdatePostResponse, BulkUpdateAllGeocodingCommonStationsBulkUpdateAllGeocodingPostResponse, GetCurrentAdminInfoAdminAuthMeGetResponse, LoginAdminAdminAuthLoginPostData, LoginAdminAdminAuthLoginPostResponse, LogoutAdminAdminAuthLogoutPostResponse, RefreshTokenAdminAuthRefreshPostResponse, GetUsersAdminUsersGetData, GetUsersAdminUsersGetResponse, CreateUserAdminUsersPostData, CreateUserAdminUsersPostResponse, GetUserAdminUsersUserIdGetData, GetUserAdminUsersUserIdGetResponse, UpdateUserAdminUsersUserIdPatchData, UpdateUserAdminUsersUserIdPatchResponse, DeleteUserAdminUsersUserIdDeleteData, DeleteUserAdminUsersUserIdDeleteResponse, UpdateUserPasswordAdminUsersUserIdPasswordPutData, UpdateUserPasswordAdminUsersUserIdPasswordPutResponse, UpdateUserRoleAdminUsersUserIdRolePutData, UpdateUserRoleAdminUsersUserIdRolePutResponse, ActivateUserAdminUsersUserIdActivatePostData, ActivateUserAdminUsersUserIdActivatePostResponse, DeactivateUserAdminUsersUserIdDeactivatePostData, DeactivateUserAdminUsersUserIdDeactivatePostResponse, UnlockUserAdminUsersUserIdUnlockPostData, UnlockUserAdminUsersUserIdUnlockPostResponse, GetAreasCommonAreasGetData, GetAreasCommonAreasGetResponse, UpsertAreaCommonAreasPostData, UpsertAreaCommonAreasPostResponse, GetAreaByIdCommonAreasAreaIdGetData, GetAreaByIdCommonAreasAreaIdGetResponse, DeleteAreaCommonAreasAreaIdDeleteData, DeleteAreaCommonAreasAreaIdDeleteResponse, UpsertAreaRouteCommonAreasAreaIdRoutesPostData, UpsertAreaRouteCommonAreasAreaIdRoutesPostResponse, CalculateRouteFromStationsCommonAreasCalculateRoutePostData, CalculateRouteFromStationsCommonAreasCalculateRoutePostResponse, GetAreaRouteCommonAreasAreaIdRoutesDayOfWeekGetData, GetAreaRouteCommonAreasAreaIdRoutesDayOfWeekGetResponse, ListDailyReportsAdminReportsListGetData, ListDailyReportsAdminReportsListGetResponse, GetDailyReportsAdminReportsGetData, GetDailyReportsAdminReportsGetResponse, GetDailyReportAdminReportsReportIdGetData, GetDailyReportAdminReportsReportIdGetResponse, UpdateDailyReportAdminReportsReportIdPutData, UpdateDailyReportAdminReportsReportIdPutResponse, DeleteDailyReportAdminReportsReportIdDeleteData, DeleteDailyReportAdminReportsReportIdDeleteResponse, UpdateReportStatusAdminReportsReportIdStatusPutData, UpdateReportStatusAdminReportsReportIdStatusPutResponse, GetWorkDashboardAdminWorkDashboardGetData, GetWorkDashboardAdminWorkDashboardGetResponse, GetCurrentAdminInfoDriverAuthMeGetResponse, LoginDriverDriverAuthLoginPostData, LoginDriverDriverAuthLoginPostResponse, RefreshTokenDriverAuthRefreshPostData, RefreshTokenDriverAuthRefreshPostResponse, ChangePasswordDriverAuthPasswordChangePostData, ChangePasswordDriverAuthPasswordChangePostResponse, StartPickUpDriverWorkStartPutData, StartPickUpDriverWorkStartPutResponse, VisitStationDriverWorkVisitPostData, VisitStationDriverWorkVisitPostResponse, RecordLocationDriverWorkLocationPutData, RecordLocationDriverWorkLocationPutResponse, GetAreaStationsDriverAreasAreaIdStationsGetData, GetAreaStationsDriverAreasAreaIdStationsGetResponse, CreateAreaStationDriverAreasAreaIdStationsPostData, CreateAreaStationDriverAreasAreaIdStationsPostResponse, UpdateAreaStationDaysDriverAreasAreaIdStationsStationIdDaysPutData, UpdateAreaStationDaysDriverAreasAreaIdStationsStationIdDaysPutResponse, ReorderAreaStationsDriverAreasAreaIdStationsReorderPutData, ReorderAreaStationsDriverAreasAreaIdStationsReorderPutResponse, DeleteAreaStationDriverAreasAreaIdStationsStationIdDeleteData, DeleteAreaStationDriverAreasAreaIdStationsStationIdDeleteResponse, ListDailyReportsDriverReportsGetData, ListDailyReportsDriverReportsGetResponse, CreateDailyReportDriverReportsPostData, CreateDailyReportDriverReportsPostResponse, GetDailyReportDriverReportsReportIdGetData, GetDailyReportDriverReportsReportIdGetResponse, UpdateDailyReportDriverReportsReportIdPutData, UpdateDailyReportDriverReportsReportIdPutResponse, DeleteDailyReportDriverReportsReportIdDeleteData, DeleteDailyReportDriverReportsReportIdDeleteResponse } from './types.gen';

/**
 * アプリケーションの稼働確認
 * @returns string Successful Response
 * @throws ApiError
 */
export const healthRootHealthzGet = (): CancelablePromise<HealthRootHealthzGetResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/healthz'
}); };

/**
 * データベース接続チェック
 * @returns string Successful Response
 * @throws ApiError
 */
export const checkDatabaseHealthzDbGet = (): CancelablePromise<CheckDatabaseHealthzDbGetResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/healthz/db'
}); };

/**
 * ステーション一覧を取得
 * ステーションの一覧を取得します。検索、曜日、有効状態でフィルタリング可能です。
 * @param data The data for the request.
 * @param data.searchQuery 検索キーワード
 * @param data.daysOfWeek 回収曜日(カンマ区切りで複数指定可能)
 * @param data.isActive 有効状態
 * @param data.page
 * @param data.size
 * @returns ApiResponse_Page_StationListResponse__ErrorDetail_ Successful Response
 * @throws ApiError
 */
export const getStationsCommonStationsListGet = (data: GetStationsCommonStationsListGetData = {}): CancelablePromise<GetStationsCommonStationsListGetResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/common/stations/list',
    query: {
        search_query: data.searchQuery,
        days_of_week: data.daysOfWeek,
        is_active: data.isActive,
        page: data.page,
        size: data.size
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * ステーション詳細を取得
 * 指定したIDのステーション詳細情報を取得します。
 * @param data The data for the request.
 * @param data.stationId
 * @returns ApiResponse_StationDetailResponse_ErrorDetail_ Successful Response
 * @throws ApiError
 */
export const getStationByIdCommonStationsStationIdGet = (data: GetStationByIdCommonStationsStationIdGetData): CancelablePromise<GetStationByIdCommonStationsStationIdGetResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/common/stations/{station_id}',
    path: {
        station_id: data.stationId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * ステーションを削除
 * 指定されたステーションとその関連データを削除します。
 * @param data The data for the request.
 * @param data.stationId
 * @returns ApiResponse_str_ErrorDetail_ Successful Response
 * @throws ApiError
 */
export const deleteStationCommonStationsStationIdDelete = (data: DeleteStationCommonStationsStationIdDeleteData): CancelablePromise<DeleteStationCommonStationsStationIdDeleteResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/common/stations/{station_id}',
    path: {
        station_id: data.stationId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * ステーションを作成または更新
 * IDの有無に応じて、新規作成または更新を行います。
 * @param data The data for the request.
 * @param data.requestBody
 * @returns ApiResponse_StationDetailResponse_ErrorDetail_ Successful Response
 * @throws ApiError
 */
export const upsertStationCommonStationsPost = (data: UpsertStationCommonStationsPostData): CancelablePromise<UpsertStationCommonStationsPostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/common/stations/',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * 一括ジオコーディング更新
 * 住所情報から緯度経度と郵便番号を一括更新します。
 * @param data The data for the request.
 * @param data.requestBody
 * @returns ApiResponse_BulkGeocodingResponse_ErrorDetail_ Successful Response
 * @throws ApiError
 */
export const bulkGeocodingUpdateCommonStationsBulkGeocodingUpdatePost = (data: BulkGeocodingUpdateCommonStationsBulkGeocodingUpdatePostData): CancelablePromise<BulkGeocodingUpdateCommonStationsBulkGeocodingUpdatePostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/common/stations/bulk-geocoding-update',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * 全ステーションの一括ジオコーディング更新
 * DBに登録されている全ステーションの住所情報から緯度経度と郵便番号を一括更新します。
 * @returns ApiResponse_BulkGeocodingResponse_ErrorDetail_ Successful Response
 * @throws ApiError
 */
export const bulkUpdateAllGeocodingCommonStationsBulkUpdateAllGeocodingPost = (): CancelablePromise<BulkUpdateAllGeocodingCommonStationsBulkUpdateAllGeocodingPostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/common/stations/bulk-update-all-geocoding'
}); };

/**
 * 現在のユーザー情報取得
 * 現在ログインしている管理者自身の情報を取得します
 * @returns ApiResponse_Union_UserProfileResponse__NoneType__ErrorDetail_ Successful Response
 * @throws ApiError
 */
export const getCurrentAdminInfoAdminAuthMeGet = (): CancelablePromise<GetCurrentAdminInfoAdminAuthMeGetResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/admin/auth/me'
}); };

/**
 * 管理者ログイン
 * 管理者アカウントでログインし、認証クッキーを設定します
 * @param data The data for the request.
 * @param data.requestBody
 * @returns ApiResponse_UserResponse_ErrorDetail_ Successful Response
 * @throws ApiError
 */
export const loginAdminAdminAuthLoginPost = (data: LoginAdminAdminAuthLoginPostData): CancelablePromise<LoginAdminAdminAuthLoginPostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/admin/auth/login',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * 管理者ログアウト
 * 認証クッキーを削除してログアウトします
 * @returns ApiResponse_NoneType_ErrorDetail_ Successful Response
 * @throws ApiError
 */
export const logoutAdminAdminAuthLogoutPost = (): CancelablePromise<LogoutAdminAdminAuthLogoutPostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/admin/auth/logout'
}); };

/**
 * トークンリフレッシュ
 * リフレッシュトークンを使用してアクセストークンを更新します
 * @returns ApiResponse_NoneType_ErrorDetail_ Successful Response
 * @throws ApiError
 */
export const refreshTokenAdminAuthRefreshPost = (): CancelablePromise<RefreshTokenAdminAuthRefreshPostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/admin/auth/refresh'
}); };

/**
 * ユーザー一覧取得
 * 条件によるフィルタリングが可能なユーザー一覧を取得します
 * @param data The data for the request.
 * @param data.role 権限でフィルタ
 * @param data.isActive 有効/無効でフィルタ
 * @param data.search 名前・メールで検索
 * @param data.page
 * @param data.size
 * @returns ApiResponse_Page_UserResponse__ErrorDetail_ Successful Response
 * @throws ApiError
 */
export const getUsersAdminUsersGet = (data: GetUsersAdminUsersGetData = {}): CancelablePromise<GetUsersAdminUsersGetResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/admin/users/',
    query: {
        role: data.role,
        is_active: data.isActive,
        search: data.search,
        page: data.page,
        size: data.size
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * ユーザー作成
 * 新規ユーザーを作成します
 * @param data The data for the request.
 * @param data.requestBody
 * @returns ApiResponse_UserResponse_ErrorDetail_ Successful Response
 * @throws ApiError
 */
export const createUserAdminUsersPost = (data: CreateUserAdminUsersPostData): CancelablePromise<CreateUserAdminUsersPostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/admin/users/',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * ユーザー詳細取得
 * 指定IDのユーザー詳細情報を取得します
 * @param data The data for the request.
 * @param data.userId ユーザーID
 * @returns ApiResponse_UserResponse_ErrorDetail_ Successful Response
 * @throws ApiError
 */
export const getUserAdminUsersUserIdGet = (data: GetUserAdminUsersUserIdGetData): CancelablePromise<GetUserAdminUsersUserIdGetResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/admin/users/{user_id}',
    path: {
        user_id: data.userId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * ユーザー情報更新
 * ユーザー情報を部分的に更新します
 * @param data The data for the request.
 * @param data.userId ユーザーID
 * @param data.requestBody
 * @returns ApiResponse_UserResponse_ErrorDetail_ Successful Response
 * @throws ApiError
 */
export const updateUserAdminUsersUserIdPatch = (data: UpdateUserAdminUsersUserIdPatchData): CancelablePromise<UpdateUserAdminUsersUserIdPatchResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/admin/users/{user_id}',
    path: {
        user_id: data.userId
    },
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * ユーザー削除
 * ユーザーを削除します
 * @param data The data for the request.
 * @param data.userId ユーザーID
 * @returns ApiResponse_str_ErrorDetail_ Successful Response
 * @throws ApiError
 */
export const deleteUserAdminUsersUserIdDelete = (data: DeleteUserAdminUsersUserIdDeleteData): CancelablePromise<DeleteUserAdminUsersUserIdDeleteResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/admin/users/{user_id}',
    path: {
        user_id: data.userId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * パスワード強制変更
 * 管理者権限でユーザーのパスワードを変更します
 * @param data The data for the request.
 * @param data.userId ユーザーID
 * @param data.requestBody
 * @returns ApiResponse_UserResponse_ErrorDetail_ Successful Response
 * @throws ApiError
 */
export const updateUserPasswordAdminUsersUserIdPasswordPut = (data: UpdateUserPasswordAdminUsersUserIdPasswordPutData): CancelablePromise<UpdateUserPasswordAdminUsersUserIdPasswordPutResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/admin/users/{user_id}/password',
    path: {
        user_id: data.userId
    },
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * 権限変更
 * ユーザーの権限(ロール)を変更します
 * @param data The data for the request.
 * @param data.userId ユーザーID
 * @param data.requestBody
 * @returns ApiResponse_UserResponse_ErrorDetail_ Successful Response
 * @throws ApiError
 */
export const updateUserRoleAdminUsersUserIdRolePut = (data: UpdateUserRoleAdminUsersUserIdRolePutData): CancelablePromise<UpdateUserRoleAdminUsersUserIdRolePutResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/admin/users/{user_id}/role',
    path: {
        user_id: data.userId
    },
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * ユーザー有効化
 * 無効状態のユーザーを有効化します
 * @param data The data for the request.
 * @param data.userId ユーザーID
 * @returns ApiResponse_UserResponse_ErrorDetail_ Successful Response
 * @throws ApiError
 */
export const activateUserAdminUsersUserIdActivatePost = (data: ActivateUserAdminUsersUserIdActivatePostData): CancelablePromise<ActivateUserAdminUsersUserIdActivatePostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/admin/users/{user_id}/activate',
    path: {
        user_id: data.userId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * ユーザー無効化
 * 有効状態のユーザーを無効化します
 * @param data The data for the request.
 * @param data.userId ユーザーID
 * @returns ApiResponse_UserResponse_ErrorDetail_ Successful Response
 * @throws ApiError
 */
export const deactivateUserAdminUsersUserIdDeactivatePost = (data: DeactivateUserAdminUsersUserIdDeactivatePostData): CancelablePromise<DeactivateUserAdminUsersUserIdDeactivatePostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/admin/users/{user_id}/deactivate',
    path: {
        user_id: data.userId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * アカウントロック解除
 * ロックされたユーザーアカウントのロックを解除します
 * @param data The data for the request.
 * @param data.userId ユーザーID
 * @returns ApiResponse_UserResponse_ErrorDetail_ Successful Response
 * @throws ApiError
 */
export const unlockUserAdminUsersUserIdUnlockPost = (data: UnlockUserAdminUsersUserIdUnlockPostData): CancelablePromise<UnlockUserAdminUsersUserIdUnlockPostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/admin/users/{user_id}/unlock',
    path: {
        user_id: data.userId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * エリア一覧を取得
 * エリアの一覧情報を取得します
 * @param data The data for the request.
 * @param data.search
 * @param data.page
 * @param data.size
 * @returns ApiResponse_Page_AreaListResponse__ErrorDetail_ Successful Response
 * @throws ApiError
 */
export const getAreasCommonAreasGet = (data: GetAreasCommonAreasGetData = {}): CancelablePromise<GetAreasCommonAreasGetResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/common/areas/',
    query: {
        search: data.search,
        page: data.page,
        size: data.size
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * エリアを作成または更新
 * IDの有無に応じて、新規作成または更新を行います
 * @param data The data for the request.
 * @param data.requestBody
 * @returns ApiResponse_AreaDetailResponse_ErrorDetail_ Successful Response
 * @throws ApiError
 */
export const upsertAreaCommonAreasPost = (data: UpsertAreaCommonAreasPostData): CancelablePromise<UpsertAreaCommonAreasPostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/common/areas/',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * エリア詳細を取得
 * 指定されたエリアの詳細情報を取得します
 * @param data The data for the request.
 * @param data.areaId
 * @returns ApiResponse_AreaDetailResponse_ErrorDetail_ Successful Response
 * @throws ApiError
 */
export const getAreaByIdCommonAreasAreaIdGet = (data: GetAreaByIdCommonAreasAreaIdGetData): CancelablePromise<GetAreaByIdCommonAreasAreaIdGetResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/common/areas/{area_id}',
    path: {
        area_id: data.areaId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * エリアを削除
 * 指定されたエリアを削除します
 * @param data The data for the request.
 * @param data.areaId
 * @returns ApiResponse_str_ErrorDetail_ Successful Response
 * @throws ApiError
 */
export const deleteAreaCommonAreasAreaIdDelete = (data: DeleteAreaCommonAreasAreaIdDeleteData): CancelablePromise<DeleteAreaCommonAreasAreaIdDeleteResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/common/areas/{area_id}',
    path: {
        area_id: data.areaId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * エリアルート情報のUpsert
 * 特定エリアに対するルート情報のUpsertを行います
 * @param data The data for the request.
 * @param data.areaId
 * @param data.requestBody
 * @returns ApiResponse_NoneType_ErrorDetail_ Successful Response
 * @throws ApiError
 */
export const upsertAreaRouteCommonAreasAreaIdRoutesPost = (data: UpsertAreaRouteCommonAreasAreaIdRoutesPostData): CancelablePromise<UpsertAreaRouteCommonAreasAreaIdRoutesPostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/common/areas/{area_id}/routes',
    path: {
        area_id: data.areaId
    },
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Station情報からルートを計算してデータベースに保存
 * 指定されたStation情報からMapBox APIを使用して最適なルートを計算し、結果をデータベースに保存します
 * @param data The data for the request.
 * @param data.requestBody
 * @returns ApiResponse_RouteCalculationResponse_ErrorDetail_ Successful Response
 * @throws ApiError
 */
export const calculateRouteFromStationsCommonAreasCalculateRoutePost = (data: CalculateRouteFromStationsCommonAreasCalculateRoutePostData): CancelablePromise<CalculateRouteFromStationsCommonAreasCalculateRoutePostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/common/areas/calculate-route',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * エリアルート取得
 * エリアの特定曜日のルート情報を取得します
 * @param data The data for the request.
 * @param data.areaId
 * @param data.dayOfWeek
 * @returns ApiResponse_AreaRouteDetail_ErrorDetail_ Successful Response
 * @throws ApiError
 */
export const getAreaRouteCommonAreasAreaIdRoutesDayOfWeekGet = (data: GetAreaRouteCommonAreasAreaIdRoutesDayOfWeekGetData): CancelablePromise<GetAreaRouteCommonAreasAreaIdRoutesDayOfWeekGetResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/common/areas/{area_id}/routes/{day_of_week}',
    path: {
        area_id: data.areaId,
        day_of_week: data.dayOfWeek
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * 日報一覧を検索
 * 日報の一覧を取得します。検索キーワードとユーザーIDでフィルタリング可能です。
 * @param data The data for the request.
 * @param data.requestBody
 * @param data.searchQuery
 * @param data.userId
 * @returns ApiResponse_Page_DailyReportListResponse__ErrorDetail_ Successful Response
 * @throws ApiError
 */
export const listDailyReportsAdminReportsListGet = (data: ListDailyReportsAdminReportsListGetData): CancelablePromise<ListDailyReportsAdminReportsListGetResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/admin/reports/list',
    query: {
        search_query: data.searchQuery,
        user_id: data.userId
    },
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * 日報一覧を取得
 * 日報の一覧を取得します。ユーザーIDやステータスでフィルタリング可能です。
 * @param data The data for the request.
 * @param data.userId
 * @param data.status
 * @param data.page
 * @param data.size
 * @returns ApiResponse_Page_DailyReportListResponse__ErrorDetail_ Successful Response
 * @throws ApiError
 */
export const getDailyReportsAdminReportsGet = (data: GetDailyReportsAdminReportsGetData = {}): CancelablePromise<GetDailyReportsAdminReportsGetResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/admin/reports',
    query: {
        user_id: data.userId,
        status: data.status,
        page: data.page,
        size: data.size
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * 日報詳細を取得
 * 指定されたIDの日報詳細を取得します。
 * @param data The data for the request.
 * @param data.reportId
 * @returns ApiResponse_DailyReportResponse_ErrorDetail_ Successful Response
 * @throws ApiError
 */
export const getDailyReportAdminReportsReportIdGet = (data: GetDailyReportAdminReportsReportIdGetData): CancelablePromise<GetDailyReportAdminReportsReportIdGetResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/admin/reports/{report_id}',
    path: {
        report_id: data.reportId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * 日報を更新
 * 指定されたIDの日報を更新します。
 * @param data The data for the request.
 * @param data.reportId
 * @param data.requestBody
 * @returns ApiResponse_DailyReportResponse_ErrorDetail_ Successful Response
 * @throws ApiError
 */
export const updateDailyReportAdminReportsReportIdPut = (data: UpdateDailyReportAdminReportsReportIdPutData): CancelablePromise<UpdateDailyReportAdminReportsReportIdPutResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/admin/reports/{report_id}',
    path: {
        report_id: data.reportId
    },
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * 日報を削除
 * 指定されたIDの日報を削除します。
 * @param data The data for the request.
 * @param data.reportId
 * @returns ApiResponse_str_ErrorDetail_ Successful Response
 * @throws ApiError
 */
export const deleteDailyReportAdminReportsReportIdDelete = (data: DeleteDailyReportAdminReportsReportIdDeleteData): CancelablePromise<DeleteDailyReportAdminReportsReportIdDeleteResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/admin/reports/{report_id}',
    path: {
        report_id: data.reportId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * 日報のステータスを更新
 * 指定されたIDの日報のステータスを更新します。
 * @param data The data for the request.
 * @param data.reportId
 * @param data.status
 * @returns ApiResponse_DailyReportResponse_ErrorDetail_ Successful Response
 * @throws ApiError
 */
export const updateReportStatusAdminReportsReportIdStatusPut = (data: UpdateReportStatusAdminReportsReportIdStatusPutData): CancelablePromise<UpdateReportStatusAdminReportsReportIdStatusPutResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/admin/reports/{report_id}/status',
    path: {
        report_id: data.reportId
    },
    query: {
        status: data.status
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * 作業ダッシュボードデータを取得
 * 指定された日付の作業データ、回収状況、ルート情報を包括的に取得します。ドライバーごとの予定ルート情報、実績ルート情報、ステーションの回収予定・回収未済・回収漏れ、全体の回収予定率を含みます。
 * @param data The data for the request.
 * @param data.targetDate 取得対象日(YYYY-MM-DD)
 * @returns ApiResponse_WorkDashboardResponse_ErrorDetail_ 作業ダッシュボード情報(今日の作業、ルート詳細、ステーション状況、回収統計を含む)
 * @throws ApiError
 */
export const getWorkDashboardAdminWorkDashboardGet = (data: GetWorkDashboardAdminWorkDashboardGetData = {}): CancelablePromise<GetWorkDashboardAdminWorkDashboardGetResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/admin/work/dashboard',
    query: {
        target_date: data.targetDate
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * 現在のユーザー情報取得
 * 現在ログインしているドライバー自身の情報を取得します
 * @returns ApiResponse_Union_UserProfileResponse__NoneType__ErrorDetail_ Successful Response
 * @throws ApiError
 */
export const getCurrentAdminInfoDriverAuthMeGet = (): CancelablePromise<GetCurrentAdminInfoDriverAuthMeGetResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/driver/auth/me'
}); };

/**
 * ドライバーログイン
 * ドライバーアカウントでログインし、JWTトークンを取得します
 * @param data The data for the request.
 * @param data.requestBody
 * @returns ApiResponse_TokenResponse_ErrorDetail_ Successful Response
 * @throws ApiError
 */
export const loginDriverDriverAuthLoginPost = (data: LoginDriverDriverAuthLoginPostData): CancelablePromise<LoginDriverDriverAuthLoginPostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/driver/auth/login',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * トークンリフレッシュ
 * リフレッシュトークンを使用して新しいアクセストークンを取得します
 * @param data The data for the request.
 * @param data.requestBody
 * @returns ApiResponse_TokenResponse_ErrorDetail_ Successful Response
 * @throws ApiError
 */
export const refreshTokenDriverAuthRefreshPost = (data: RefreshTokenDriverAuthRefreshPostData): CancelablePromise<RefreshTokenDriverAuthRefreshPostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/driver/auth/refresh',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * ドライバーパスワード変更
 * 現在のパスワードを確認して新しいパスワードに変更します
 * @param data The data for the request.
 * @param data.requestBody
 * @returns ApiResponse_NoneType_ErrorDetail_ Successful Response
 * @throws ApiError
 */
export const changePasswordDriverAuthPasswordChangePost = (data: ChangePasswordDriverAuthPasswordChangePostData): CancelablePromise<ChangePasswordDriverAuthPasswordChangePostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/driver/auth/password/change',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * ルート回収作業を開始
 * 指定されたルートの回収作業を開始し、現在の状態を返します
 * @param data The data for the request.
 * @param data.requestBody
 * @returns ApiResponse_DriverWorkResponse_ErrorDetail_ 回収ルートの現在の状態と関連ステーション情報
 * @throws ApiError
 */
export const startPickUpDriverWorkStartPut = (data: StartPickUpDriverWorkStartPutData): CancelablePromise<StartPickUpDriverWorkStartPutResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/driver/work/start',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * ステーション到着時の処理
 * ステーションへの到着を記録し、現在のルート状態を返します
 * @param data The data for the request.
 * @param data.requestBody
 * @returns ApiResponse_DriverWorkResponse_ErrorDetail_ 更新されたルート情報とステーションのリスト
 * @throws ApiError
 */
export const visitStationDriverWorkVisitPost = (data: VisitStationDriverWorkVisitPostData): CancelablePromise<VisitStationDriverWorkVisitPostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/driver/work/visit',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * ドライバーの現在位置を記録
 * ドライバーの現在位置情報を記録します
 * @param data The data for the request.
 * @param data.requestBody
 * @returns ApiResponse_NoneType_ErrorDetail_ 位置情報記録完了メッセージ
 * @throws ApiError
 */
export const recordLocationDriverWorkLocationPut = (data: RecordLocationDriverWorkLocationPutData): CancelablePromise<RecordLocationDriverWorkLocationPutResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/driver/work/location',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * ドライバー向けエリアステーション一覧取得
 * ドライバーが指定したエリアのステーション一覧を取得します
 * @param data The data for the request.
 * @param data.areaId
 * @returns ApiResponse_list_AreaStationRecord__ErrorDetail_ Successful Response
 * @throws ApiError
 */
export const getAreaStationsDriverAreasAreaIdStationsGet = (data: GetAreaStationsDriverAreasAreaIdStationsGetData): CancelablePromise<GetAreaStationsDriverAreasAreaIdStationsGetResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/driver/areas/{area_id}/stations',
    path: {
        area_id: data.areaId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * ドライバー向けエリアステーション作成
 * ドライバーが指定したエリアに新しいステーションを追加します
 * @param data The data for the request.
 * @param data.areaId
 * @param data.requestBody
 * @returns ApiResponse_DriverUpdateResponse_ErrorDetail_ Successful Response
 * @throws ApiError
 */
export const createAreaStationDriverAreasAreaIdStationsPost = (data: CreateAreaStationDriverAreasAreaIdStationsPostData): CancelablePromise<CreateAreaStationDriverAreasAreaIdStationsPostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/driver/areas/{area_id}/stations',
    path: {
        area_id: data.areaId
    },
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * ドライバー向けエリアステーション曜日変更
 * ドライバーが指定したエリアのステーションの収集曜日を変更します
 * @param data The data for the request.
 * @param data.areaId
 * @param data.stationId
 * @param data.requestBody
 * @returns ApiResponse_DriverUpdateResponse_ErrorDetail_ Successful Response
 * @throws ApiError
 */
export const updateAreaStationDaysDriverAreasAreaIdStationsStationIdDaysPut = (data: UpdateAreaStationDaysDriverAreasAreaIdStationsStationIdDaysPutData): CancelablePromise<UpdateAreaStationDaysDriverAreasAreaIdStationsStationIdDaysPutResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/driver/areas/{area_id}/stations/{station_id}/days',
    path: {
        area_id: data.areaId,
        station_id: data.stationId
    },
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * ドライバー向けエリアステーション並べ替え
 * ドライバーがエリア内のステーションの順序を変更します
 * @param data The data for the request.
 * @param data.areaId
 * @param data.requestBody
 * @returns ApiResponse_DriverUpdateResponse_ErrorDetail_ Successful Response
 * @throws ApiError
 */
export const reorderAreaStationsDriverAreasAreaIdStationsReorderPut = (data: ReorderAreaStationsDriverAreasAreaIdStationsReorderPutData): CancelablePromise<ReorderAreaStationsDriverAreasAreaIdStationsReorderPutResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/driver/areas/{area_id}/stations/reorder',
    path: {
        area_id: data.areaId
    },
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * ドライバー向けエリアステーション削除
 * ドライバーが指定したエリアからステーションを削除します
 * @param data The data for the request.
 * @param data.areaId
 * @param data.stationId
 * @returns ApiResponse_DriverUpdateResponse_ErrorDetail_ Successful Response
 * @throws ApiError
 */
export const deleteAreaStationDriverAreasAreaIdStationsStationIdDelete = (data: DeleteAreaStationDriverAreasAreaIdStationsStationIdDeleteData): CancelablePromise<DeleteAreaStationDriverAreasAreaIdStationsStationIdDeleteResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/driver/areas/{area_id}/stations/{station_id}',
    path: {
        area_id: data.areaId,
        station_id: data.stationId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * 日報一覧を取得
 * 日報の一覧を取得します。ユーザーIDやステータスでフィルタリング可能です。
 * @param data The data for the request.
 * @param data.status
 * @param data.page
 * @param data.size
 * @returns ApiResponse_Page_DailyReportListResponse__ErrorDetail_ Successful Response
 * @throws ApiError
 */
export const listDailyReportsDriverReportsGet = (data: ListDailyReportsDriverReportsGetData = {}): CancelablePromise<ListDailyReportsDriverReportsGetResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/driver/reports',
    query: {
        status: data.status,
        page: data.page,
        size: data.size
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * 日報を作成
 * 新しい日報を作成します。
 * @param data The data for the request.
 * @param data.requestBody
 * @returns ApiResponse_DailyReportResponse_ErrorDetail_ Successful Response
 * @throws ApiError
 */
export const createDailyReportDriverReportsPost = (data: CreateDailyReportDriverReportsPostData): CancelablePromise<CreateDailyReportDriverReportsPostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/driver/reports',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * 日報詳細を取得
 * 指定されたIDの日報詳細を取得します。
 * @param data The data for the request.
 * @param data.reportId
 * @returns ApiResponse_DailyReportResponse_ErrorDetail_ Successful Response
 * @throws ApiError
 */
export const getDailyReportDriverReportsReportIdGet = (data: GetDailyReportDriverReportsReportIdGetData): CancelablePromise<GetDailyReportDriverReportsReportIdGetResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/driver/reports/{report_id}',
    path: {
        report_id: data.reportId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * 日報を更新
 * 指定されたIDの日報を更新します。
 * @param data The data for the request.
 * @param data.reportId
 * @param data.requestBody
 * @returns ApiResponse_DailyReportResponse_ErrorDetail_ Successful Response
 * @throws ApiError
 */
export const updateDailyReportDriverReportsReportIdPut = (data: UpdateDailyReportDriverReportsReportIdPutData): CancelablePromise<UpdateDailyReportDriverReportsReportIdPutResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/driver/reports/{report_id}',
    path: {
        report_id: data.reportId
    },
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * 日報を削除
 * 指定されたIDの日報を削除します。
 * @param data The data for the request.
 * @param data.reportId
 * @returns ApiResponse_str_ErrorDetail_ Successful Response
 * @throws ApiError
 */
export const deleteDailyReportDriverReportsReportIdDelete = (data: DeleteDailyReportDriverReportsReportIdDeleteData): CancelablePromise<DeleteDailyReportDriverReportsReportIdDeleteResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/driver/reports/{report_id}',
    path: {
        report_id: data.reportId
    },
    errors: {
        422: 'Validation Error'
    }
}); };